import React, { useLayoutEffect } from 'react';
import { Helmet } from 'react-helmet';
import { CONFIG } from '../../config';
import majiLogo from '../../assets/img/logo-maji-landing.svg';

const BODY_CLASS = 'promo-body';

const PromoPage = () => {
  // Set synchronously before paint so the page never flashes with the global dark body styles
  useLayoutEffect(() => {
    document.body.classList.add(BODY_CLASS);

    return () => {
      document.body.classList.remove(BODY_CLASS);
    };
  }, []);

  return (
    <>
      <Helmet>
        <meta name="description" content="MAJI — Media Across Joint Interfaces. A new infrastructure for the creator economy."/>
        <title>{CONFIG.TITLE}</title>
      </Helmet>

      <main className="promo-page">
        <h1 className="promo-page__logo">
          <img src={majiLogo} alt="MAJI — Media Across Joint Interfaces"/>
        </h1>

        <p className="promo-page__tagline">A new infrastructure for the creator economy</p>

        <a className="promo-page__email" href={`mailto:${CONFIG.inquiriesEmail}`}>
          {CONFIG.inquiriesEmail}
        </a>
      </main>
    </>
  );
};

export default PromoPage;
